import { isTauri } from "@/lib/is-tauri";
import type {
  FocusRendererKind,
  PresentationVariant,
} from "@/lib/focus/focus-types";
import type { DesktopMode } from "@/stores/desktop-mode-store";

export function shouldExitPresentationForDesktopMode(
  desktopMode: DesktopMode,
  presentationVariant: PresentationVariant | null,
  denkCanvasCapture = false,
  renderer: FocusRendererKind = "canvas",
  nativeDesktop = isTauri(),
) {
  if (presentationVariant === "focus") {
    // Focus over the wall stays inside the Workspace (Part 05 Q1).
    if (renderer === "overlay") return false;
    // Canvas focus is a Compact overlay. Entering Workspace must restore its
    // canvas, even when persistent panning is off (the default for every
    // entry path).
    return desktopMode === "denk" && (nativeDesktop || denkCanvasCapture);
  }
  if (desktopMode === "denk" && denkCanvasCapture) {
    return false;
  }
  return desktopMode === "denk";
}

/** A canvas Focus another display entered owns the shared canvas: a
 *  Workspace here yields to it instead of exiting it under that display.
 *  Focus over the wall never gets here: each display's wall is its own. */
export function focusBelongsToOtherDisplay(
  focusDisplayId: number | null | undefined,
  myDisplayId: number | null,
): boolean {
  return (
    typeof focusDisplayId === "number" &&
    myDisplayId !== null &&
    focusDisplayId !== myDisplayId
  );
}
